<template>
  <VDialog
    v-model="showDialog"
    :width="width"
  >
    <VCard>
      <VCardTitle
        :class="[titleClass]"
        class="headline white--text"
        primary-title
      >
        {{ title }}
      </VCardTitle>
      <VCardText
        class="grey--text text--darken-4"
      >
        <div
          v-for="(line, index) in description"
          :key="index"
        >
          {{ line }}
          <br v-if="index < description.length -1">
        </div>
      </VCardText>
      <VDivider />
      <VCardActions>
        <VSpacer />
        <VBtn
          color="primary"
          flat
          @click="onCloseClicked"
        >
          OK
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'DescriptionDialogCard',
  props: {
    title: {
      type: String,
      default: 'error'
    },
    description: {
      type: Array,
      default: function () {
        return []
      }
    },
    dialog: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 350
    }
  },
  data () {
    return {
      showDialog: this.dialog
    }
  },
  computed: {
    titleClass: function () {
      return this.title.toLowerCase()
    }
  },
  watch: {
    dialog: function () {
      this.showDialog = this.dialog
    },
    showDialog: function () {
      this.$emit('update:dialog', this.showDialog)
    }
  },
  methods: {
    onCloseClicked () {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>

</style>
